var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('contestController', ['$scope', 'contestService', '$sce', 'loaderService', '$location',
    function ($scope, contestService, $sce, loaderService, location) {

        $scope.initialize = function () {
            $scope.hasSearched = false;
            getContestWinners();
            getActiveUpcomingContests();
        }

        function getContestWinners() {
            loaderService.show();

            contestService.getContestWinners().then(function (response) {
                $scope.contestWinners = response.data;

                $scope.winner1 = $scope.contestWinners[0];
                $scope.winner2 = $scope.contestWinners[1];
                $scope.winner3 = $scope.contestWinners[2];
                $scope.winner4 = $scope.contestWinners[3];

                loaderService.hide();
            })
        }

        function getActiveUpcomingContests() {
            loaderService.show();

            contestService.getActiveUpcomingContests().then(function (response) {
                $scope.activeContest = response.data.activeContest;
                $scope.upcomingContest = response.data.upcomingContest;

                loaderService.hide();
            })
        }

        $scope.submitContestEntry = function (contest) {
            if (contest != null) {
                localStorage.setItem("contestId", contest.contestId);
                window.location.href = "/learning-center/contest/entry?id=" + contest.contestId;
            }
        }

        $scope.viewContestWinners = function (winner) {
            window.location.href = "/learning-center/contest/past-winners?contestId=" + winner.contestId;
        }

        $scope.initialize();

    }])
